var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 24,
    viewBox: "0 0 77 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2965_39153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5446 7.67311C39.502 11.0161 42.5237 12.8816 44.8007 13.9911C47.1396 15.1296 47.9255 15.8591 47.9158 16.8768C47.8981 18.4348 46.0503 19.1216 44.3208 19.149C41.3031 19.1957 39.5495 18.3341 38.1541 17.6828L37.0672 22.7689C38.4665 23.4139 41.0575 23.9767 43.7443 24.0008C50.0511 24.0008 54.1775 20.8873 54.2 16.0604C54.2242 9.93398 45.7258 9.59501 45.7838 6.85668C45.8039 6.02657 46.5962 5.1401 48.3321 4.91465C49.1912 4.80113 51.5639 4.71417 54.2532 5.9525L55.3087 1.0314C53.8627 0.504831 52.0036 0 49.6896 0C43.7532 0 39.5776 3.15539 39.5438 7.67311M65.4536 0.424316C64.3023 0.424316 63.3313 1.09581 62.8981 2.12721L53.8884 23.6393H60.1912L61.4456 20.1731H69.1477L69.8755 23.6393H75.4303L70.5817 0.424316H65.4528M66.3345 6.69565L68.1533 15.413H63.1718L66.3345 6.69565M31.9037 0.424316L26.9359 23.6393H32.9416L37.9069 0.424316H31.9037ZM23.0189 0.424316L16.7676 16.2254L14.2395 2.79066C13.9424 1.29066 12.7709 0.425121 11.4697 0.425121H1.24993L1.10742 1.09823C3.20565 1.55314 5.5889 2.28744 7.03254 3.07327C7.9166 3.55314 8.16861 3.97263 8.45847 5.11272L13.2475 23.6385H19.5945L29.3256 0.424316H23.0189",
    fill: "url(#paint0_linear_2965_39153)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2965_39153",
    x1: 1.10742,
    y1: 12,
    x2: 75.4295,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2965_39153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 24,
    fill: "white",
    transform: "translate(0.107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4984c8c88a924d0f81be20c6cdfef64f.svg";
export { ForwardRef as ReactComponent };